import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './pages/Home.vue'
import Flakes from './pages/Flakes.vue'
import Beads from './pages/Beads.vue'
import Privacy from './pages/Privacy.vue'
import Cookie from './pages/Cookie.vue'
import {i18n} from './i18n/index.js'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  linkActiveClass: 'is-active',
  routes: [
    {
      path: '/:lang',
      component: {
        render: h => h('router-view')
      },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        
        if ( !['it','en'].includes(lang) ) {
          return next('it');
        }else{
          i18n.locale = lang
        }
      
        return next();
      },
      children: [
        {
          path: '',
          name: 'home',
          component: Home
        },
        {
          path: 'flakes',
          name: 'flakes',
          component: Flakes
        },
        {
          path: 'granulate',
          name: 'beads',
          component: Beads
        },
        {
          path: 'privacy',
          name: 'privacy',
          component: Privacy
        },
        {
          path: 'cookie',
          name: 'cookie',
          component: Cookie
        },
        
      ]
    },
    {
      path: '/*',
      name: 'root',
      component: Home,
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        
        if ( !['it','en'].includes(lang) ) {
          return next('it');
        }else{
          i18n.locale = lang
        }
        return next()
      }
    }
   
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router


// WEBPACK FOOTER //
// ./src/router.js